import { Milestone } from 'lucide-react';

const phases = [
  {
    title: 'Phase 1: Genesis',
    items: [
      'Website Launch',
      'Smart Contract Deployment',
      'Community Building',
      'Presale Launch',
      'Marketing Campaign Start'
    ],
    status: 'current'
  },
  {
    title: 'Phase 2: Quantum Leap',
    items: [
      'Token Launch',
      'CoinGecko & CMC Listings',
      'DEX Listing',
      'Genesis Game Prototype Release',
      'Community Enters the Grid',
      'Earn-as-You-Play System Integration',
      'Genesis Game Launch – While You Play, We Forge the Network'
    ],
    status: 'upcoming'
  },
  {
    title: 'Phase 3: Infrastructure Initiation',
    items: [
      'Genesis Core Chain (Testnet) Launch',
      'Ground-based Quantum Terminal Optimization',
      'Orbital Node Communication Tests',
      'Cross-chain Bridge Infrastructure Deployment',
      'AI Governance Concept Launch (Lyria v0.1)',
      'Strategic Partner Onboarding',
      'Quantum Identity System Prototype'
    ],
    status: 'upcoming'
    },
  {
  title: 'Phase 4: Decentralized Evolution',
  items: [
    'Genesis Core Chain Mainnet Launch',
    'Genesis Terminal Network Activation (Global Node Campaign)',
    'Quantum DAO Launch (with AI Advisor)',
    'Post-Quantum Wallet Integration',
    'Global Awareness Campaigns',
    'Unified Ecosystem Synchronization',
    'Full Network Decentralization'
  ],
    status: 'upcoming'
  }
];

export default function Roadmap() {
  return (
    <div className="py-10 w-full relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-4 relative z-20">
          <div className="relative">
            <div className="absolute inset-0 bg-quantum-dark/80 blur-xl"></div>
            <h2 className="relative font-tokyo text-3xl font-bold bg-gradient-to-r from-quantum-primary to-quantum-secondary bg-clip-text text-transparent mb-2">
              Roadmap
            </h2>
            <p className="relative text-sm text-quantum-light/80">From meme origins to quantum-grade infrastructure — this is the path we're forging.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 relative">
          {/* Lyria GIF positioned to appear standing on the containers */}
          <div className="absolute -top-[255px] right-0 lg:-right-[0px] w-[150px] pointer-events-none z-10">
            <img
              src="gif/lyria.gif"
              alt="Lyria"
              className="w-full h-auto"
            />
          </div>

          {phases.map((phase, index) => (
            <div key={phase.title} className={`quantum-card p-3 relative ${
              phase.status === 'current' ? 'border-quantum-primary' : ''
            }`}>
              <div className="flex items-center mb-2">
                <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 ${
                  phase.status === 'current'
                    ? 'bg-quantum-primary text-white'
                    : 'bg-white/10 text-quantum-light/50'
                }`}>
                  {index + 1}
                </div>
                <h3 className="text-base font-semibold text-quantum-light">{phase.title}</h3>
              </div>
              <ul className="space-y-2">
                {phase.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-center text-xs">
                    <Milestone className={`w-3 h-3 mr-1.5 ${
                      phase.status === 'current'
                        ? 'text-quantum-primary'
                        : 'text-quantum-light/50'
                    }`} />
                    <span className={phase.status === 'current' ? 'text-quantum-light' : 'text-quantum-light/70'}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}